import { create } from "zustand";
import { setApiConfig } from "../lib/api";

const defaultApiUrl = "http://localhost:3000";
const accountTokenKey = "ai-crm:account-token";
const userTokenKey = "ai-crm:user-token";
const apiUrlKey = "ai-crm:api-url";

function readSessionValue(key: string): string | null {
  if (typeof window === "undefined") return null;
  return window.sessionStorage.getItem(key);
}

interface AuthState {
  token: string | null;
  userJwt: string | null;
  apiUrl: string;
  isReady: boolean;
  init: (params: URLSearchParams) => void;
  setUserJwt: (jwt: string) => void;
  clearUserJwt: () => void;
  setAccountToken: (jwt: string) => void;
}

export const useAuthStore = create<AuthState>((set, get) => ({
  token: null,
  userJwt: null,
  apiUrl: defaultApiUrl,
  isReady: false,

  init: (params: URLSearchParams) => {
    const apiUrl = params.get("api_url") ?? readSessionValue(apiUrlKey) ?? defaultApiUrl;
    const token = params.get("token") ?? readSessionValue(accountTokenKey);
    const userJwt = readSessionValue(userTokenKey);

    if (typeof window !== "undefined") {
      window.sessionStorage.setItem(apiUrlKey, apiUrl);
      if (token) window.sessionStorage.setItem(accountTokenKey, token);
    }

    if (token) {
      setApiConfig(apiUrl, token);
    }

    set({ token, userJwt, apiUrl, isReady: true });
  },

  setUserJwt: (jwt: string) => {
    if (typeof window !== "undefined") {
      window.sessionStorage.setItem(userTokenKey, jwt);
    }

    set({ userJwt: jwt });
  },

  clearUserJwt: () => {
    if (typeof window !== "undefined") {
      window.sessionStorage.removeItem(userTokenKey);
      window.sessionStorage.removeItem(accountTokenKey);
    }

    set({ userJwt: null, token: null });
  },

  setAccountToken: (jwt: string) => {
    const apiUrl = get().apiUrl;

    if (typeof window !== "undefined") {
      window.sessionStorage.setItem(accountTokenKey, jwt);
    }

    setApiConfig(apiUrl, jwt);
    set({ token: jwt });
  },
}));
